export class Hack {
  constructor() {
    this._completes = [];
    this._state = 0;
    const agent = window.navigator.userAgent.toLowerCase();
    this.isRmt = -1 != agent.indexOf('rmt'); // RMT
    this.isWechat = -1 != agent.indexOf('micromessenger'); // wechat
    this.isAndroid = -1 != agent.indexOf('android'); // android
    this.isIphone = -1 != agent.indexOf('iphone') || -1 != agent.indexOf('ipad'); // iphone
    this.isHarmony = -1 !== agent.indexOf('harmonyos');
    this.isPc = !!(agent.match('mac') || agent.match('win')); // PC

    // this.isRmt = true;
    // this.isWechat = true;
    this.loadVC();
  }

  async load() {
    console.log('hack load', this.isRmt ? 'rmt' : '');
    // loading
    if (0 !== this._state) return;

    this._state = -1;
    const complete = () => {
      console.log('hack load complete');
      this._state = 1;
      for (let i = 0; i < this._completes.length; i++) {
        this._completes[i]();
      }
    };

    if (this.isRmt) {
      this.loadScript('https://assets.shmedia.tech/qiaojie/rmt-2.0.0.js').then(() => {
        setTimeout(complete, 100);
        setTimeout(() => {
          // 注册桥接方法。
          window.rmt?.registerHandler('openPay');
        }, 100);
      });
    } else {
      complete();
    }
  }

  loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = resolve;
      script.onerror = reject;
      document.getElementsByTagName('body')?.[0].appendChild(script);
    });
  }

  loadVC() {
    const search = new URLSearchParams(location.search);
    if (search.get('vc') === '1') {
      this.loadScript('https://cdn.bootcss.com/vConsole/3.3.4/vconsole.min.js').then(() => {
        setTimeout(() => {
          new window.VConsole();
          console.log('Hello world');
        }, 100);
      });
    }
  }

  execute(callback) {
    console.log('enter execute');
    this._state > 0
      ? callback()
      : (() => {
          this._completes.push(callback);
          this.load();
        })();
  }

  open({ url = '', closing = true }) {
    this.execute(() => {
      const isActionURL = url.startsWith('rmt://');
      if (!this.isRmt && isActionURL) {
        window.rmt.openAction({ actionUrl: url, closing });
      } else {
        isActionURL && (url = window.$$.util?.getParam('target', url));
        window.location.href = url;
      }
    });
  }

  async getRmtToken() {
    return new Promise((resolve) => {
      window.rmt
        ? window.rmt.getToken({
            success: (data) => {
              if (data?.token && data.token !== 'token') {
                resolve(data.token);
              } else {
                resolve('');
              }
              console.log('getToken success');
            },
            fail: () => {
              console.log('getToken fail');
              resolve('');
            }
          })
        : resolve('');
    });
  }
}
export default new Hack();
